export function generateCode128SvgPath(text: string): { path: string; width: number } {
  const patterns: { [key: string]: string } = {
    ' ': '11011001100', '!': '11001101100', '"': '11001100110', '#': '10010011000',
    '$': '10010001100', '%': '10001001100', '&': '10011001000', "'": '10011000100',
    '(': '10001100100', ')': '11001001000', '*': '11001000100', '+': '11000100100',
    ',': '10110011100', '-': '10011011100', '.': '10011001110', '/': '10111001100',
    '0': '10011100110', '1': '11001110010', '2': '11001011100', '3': '11001001110',
    '4': '11011100100', '5': '11001110100', '6': '11001110010', '7': '11011101100',
    '8': '11011001110', '9': '11001101110', ':': '11100110110', ';': '11101101100',
    '<': '11101100110', '=': '11100110010', '>': '11100110100', '?': '11101101000',
    '@': '11101100010', 'A': '11100011010', 'B': '11100011000', 'C': '11100110000',
    'D': '11000111010', 'E': '11000110010', 'F': '11000110000', 'G': '11001110000',
    'H': '11100010010', 'I': '11100010000', 'J': '11110100110', 'K': '11110100100',
    'L': '11110010110', 'M': '11110010100', 'N': '11110011010', 'O': '11110011000',
    'P': '11011011110', 'Q': '11011110110', 'R': '11011110010', 'S': '11011110100',
    'T': '11101011110', 'U': '11110101100', 'V': '11110100110', 'W': '11110100100',
    'X': '11110010110', 'Y': '11110010100', 'Z': '11110011010', '[': '11110011000',
    '\\': '11011011110', ']': '11011110110', '^': '11011110010', '_': '11011110100',
    '`': '11101011110', 'a': '11110101100', 'b': '11110100110', 'c': '11110100100',
    'd': '11110010110', 'e': '11110010100', 'f': '11110011010', 'g': '11110011000',
    'h': '11011011110', 'i': '11011110110', 'j': '11011110010', 'k': '11011110100',
    'l': '11101011110', 'm': '11110101100', 'n': '11110100110', 'o': '11110100100',
    'p': '11110010110', 'q': '11110010100', 'r': '11110011010', 's': '11110011000',
    't': '11011011110', 'u': '11011110110', 'v': '11011110010', 'w': '11011110100',
    'x': '11101011110', 'y': '11110101100', 'z': '11110100110', '{': '11110100100',
    '|': '11110010110', '}': '11110010100', '~': '11110011010'
  };

  const START_CODE_B = '11010010000';
  const STOP_CODE = '1100011101011';

  let code = START_CODE_B;
  let checksum = 104;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const codeVal = char.charCodeAt(0) - 32;
    const pattern = patterns[char] || patterns[' '];
    code += pattern;
    checksum += codeVal * (i + 1);
  }

  const checksumModulo = checksum % 103;
  let checkChar = String.fromCharCode(checksumModulo + 32);
  const checkPattern = patterns[checkChar] || patterns[' '];
  code += checkPattern;
  code += STOP_CODE;

  let path = '';
  for (let i = 0; i < code.length; i++) {
    if (code[i] === '1') {
      path += `M${i},0 L${i},100 `;
    }
  }
  const width = code.length;

  return { path, width };
}
